import { IAppContext } from "@/context/AppContext";
import { checkSessionError, provideSession } from "./utils";
import { isBackendUnavailableStatus } from "@/app/shared/api-connection-health";

export type PageGuardStatus = "ready" | "loading" | "redirected";

interface IGuardSessionMainInfoParams {
  appContext: IAppContext;
  redirectToAuth: () => void;
  onMainInfoError?: (status: string) => void;
  requireAdmin?: boolean;
}

interface IGuardSessionMainInfoResult {
  status: PageGuardStatus;
  session?: string;
}

export function guardSessionMainInfo({
  appContext,
  redirectToAuth,
  onMainInfoError,
  requireAdmin = false,
}: IGuardSessionMainInfoParams): IGuardSessionMainInfoResult {
  const session = provideSession();
  if (!session) {
    redirectToAuth();
    return { status: "redirected" };
  }

  if (appContext.hasMainInfo == false) {
    if (appContext.fetchingMainInfo == false) {
      appContext.fetchMainInfo(
        session,
        () => {},
        (errorStatus) => {
          if (checkSessionError(errorStatus)) {
            redirectToAuth();
            return;
          }
          if (isBackendUnavailableStatus(errorStatus)) {
            return;
          }
          if (onMainInfoError != undefined) {
            onMainInfoError(errorStatus);
          }
        }
      );
    }
    return { status: "loading", session };
  }

  if (requireAdmin) {
    if (appContext.isAdmin == false) {
      redirectToAuth();
      return { status: "redirected", session };
    }

    if (appContext.isAdmin != true) {
      return { status: "loading", session };
    }
  }

  return { status: "ready", session };
}
